import { USER_TYPE_AGENT, USER_TYPE_BUYER } from '../../../constants/user';

export const ONBOARDING_STEP_CREATE = 'create';
export const ONBOARDING_STEP_INVITE = 'invite';
export const ONBOARDING_STEP_PHONE = 'phone';
export const ONBOARDING_STEP_BUYING_CRITERIA = 'buying-criteria';
export const ONBOARDING_STEP_BUYBOX = 'buybox';

export const WIZARD_STEPS_BY_INTEREST = {
  [USER_TYPE_AGENT]: [
    ONBOARDING_STEP_BUYING_CRITERIA,
    ONBOARDING_STEP_CREATE,
    ONBOARDING_STEP_PHONE,
  ],
  [USER_TYPE_BUYER]: [
    ONBOARDING_STEP_CREATE,
    ONBOARDING_STEP_BUYING_CRITERIA,
    ONBOARDING_STEP_PHONE,
    ONBOARDING_STEP_BUYBOX,
  ],
};

export const ONBOARDING_DEFAULT_PARAMS = {
  // step 1
  organizationName: '',
  entityName: '',
  additionalEntities: [],
  // step 2
  buyingStrategy: [],
  buyingVolume: '',
  ownedVolume: '',
  currentGoal: '',
  currentGoalExplanation: [],
  // step 3
  phoneNumber: {},
  // step 4
  buyBoxList: [],
};

export const HIDDEN_BUTTON_STEPS = [ONBOARDING_STEP_INVITE];
